<template>
    <b-card v-if="route" @dragover.prevent @drop="ondropToRoute($event)" draggable="true"
        @click="selectRoute()">
        <b-card-title  @click="expanded = !expanded">
            <b-button-toolbar :style="{background:route.color}">
                <div class="colorshow" :style="{background:route.color}"></div>
                <b-button-group size="sm">
                    <b-button size="sm" v-if="route.selected" @click="changeselected($event, false)">
                        <i class="fa-solid fa-check"></i>
                    </b-button>
                    <b-button size="sm" v-if="!route.selected" variant="outline-secondary"
                        @click="changeselected($event, true)">
                        <i class="fa-solid fa-check"></i>
                    </b-button>
                    <b-button size="sm" title="Expandera" variant="primary">                       
                        {{ route.name ? route.name : '-----------' }}                                                
                        <b-badge v-if="route.missingGeos && route.missingGeos.length > 0" variant="danger"
                            title="Geodkning saknas på vissa adresser">{{ route.missingGeos.length }}</b-badge>
                        <b-dropdown variant="light" size="sm">
                            <!-- <b-dropdown-item @click="autoGeoCodeRoute()">
                                <i class="fa-solid fa-map-pin"></i> 
                                Geokoda saknade
                            </b-dropdown-item> -->
                            <b-dropdown-item v-for="(c,i) in getRouteCommands()" :key="i" @click="onroutecommand($event,c)" :title="c.title" >
                                <i :class="`fa-solid ${c.icon}`"></i> 
                                {{c.text}}
                            </b-dropdown-item>
                            
                        </b-dropdown>
                    </b-button>                    
                </b-button-group>                
            </b-button-toolbar>
            <!-- {{ route.name }} -->

        </b-card-title>
        <b-card-body>
            <!-- {{ route.selected }} -->
            <b-button-toolbar>
                <b-button-group class="mx-1" v-if="route.kpis">
                    <b-button size="sm" title="Antal stopp" variant="outline-secondary">{{ route.kpis.stopCount
                    }}</b-button>
                    <b-button size="sm" title="Antal bokningar" variant="outline-secondary">{{ route.kpis.bookingsCount
                    }}</b-button>
                    <b-button size="sm" title="Antal kolli" variant="outline-secondary">{{ route.kpis.collisCount
                    }}</b-button>
                    <b-button size="sm" title="Antal km" variant="outline-secondary">{{ Math.round(route.kpis.kms) }}</b-button>
                    <b-button size="sm" title="Total körtid" variant="outline-secondary">{{ Math.round(route.kpis.driverMinutes)
                    }}</b-button>
                    <b-button size="sm" title="Total arbetstid" variant="outline-secondary">{{ Math.round(route.kpis.totMinutes)
                    }}</b-button>
                    <b-button size="sm" title="Total kostnad" variant="outline-secondary">{{ Math.round(route.kpis.cost) }}</b-button>           
                </b-button-group>
            </b-button-toolbar>
            <missinggeos v-if="expanded" :missinggeos="route.missingGeos" @geocoded="onGeoCoded($event)">
                <!-- <button @click="alert('i routedetails')">Klick</button>  -->                
            </missinggeos>

            <b-row v-if="expanded">
                <b-col>
                    <b-row v-for="(s, i) in route.stops" :key="i" draggable="true" @click="toggleStopExpand(s)"
                        class="stoprow" @mouseover="highlightOnMap(s)" @mouseleave="highlightclear()"
                        @dragstart="dragStart_Stop($event, s)" @dragover.prevent
                        @drop="ondropToStop($event,s,i)"
                        >
                        <!-- {{isStopSelected(s)}} -->
                        <i class="fa-solid fa-square-check" v-if="!s.locked && isStopSelected(s)" @click="setStopSelected($event,s,false)" title="Avmarkera - Ta bort från urval"></i>
                        <i class="fa-regular fa-square" v-if="!s.locked && !isStopSelected(s)" @click="setStopSelected($event,s,true)" title="Markera - Lägg till i urval" ></i>                       
                        <i class="fa-solid fa-square-plus" v-if="i==0" @click="setAllStopSelected($event,s,true)" title="Markera alla - lägg till i urval"></i>                        
                        <i class="fa-solid fa-square-minus" v-if="i==0" @click="setAllStopSelected($event,s,false)" title="Avmarkera alla - ta bort från urval"></i>

                        &nbsp;
                        <i class="fa-regular fa-lock" v-if="s.locked"></i>
                        <b-badge variant="light">{{ i+1 }}</b-badge>
                        
                        <!-- <i class="fa-solid fa-location-pin"></i> -->
                        &nbsp;{{ s.text }}
                        <b-badge variant="info" v-if="s.actions.length>1" title="Flera order">{{ s.actions.length }}</b-badge>
                        <stopdetails :stop="s" v-if="isStopExpanded(s)" 
                            @setdrag="onsetdrag($event)" 
                            @stopworktimechanged="onStopWorkTimeChanged($event,s)"
                            @geocoded="onStopGeoCoded($event)"
                            @isolateaction="isolateAction($event,s)"                            
                            ></stopdetails>                        
                    </b-row>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import Missinggeos from "./missinggeos.vue";
import stopdetails from "./stopdetails.vue"

import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'routedetails',
    components: { Missinggeos, stopdetails },
    props: { route: Object,cmds:Array,selectedStops:Array },
    data() {
        return {
            expanded: false,
            expandedstops: [],
            
        }
    },
    methods: {
        toggleStopExpand(s) {
            if (!this.isStopExpanded(s))
                this.expandedstops.push(s);
            else
                this.expandedstops = this.expandedstops.filter(x => x != s);
        },
        isStopExpanded(s) {
            return this.expandedstops.indexOf(s) >= 0;
        },
        onGeoCoded(ev) {
            //Perform update on all missing geos?
            var bIds = this.route.bookings
                .filter(x => this.isBookingMissingGeo(x))
                .map(x => x.id);

            var p = { bookingIds: bIds, geoPlaceId: ev.id };
            api.post('/api/geo/UpdateBookingGeoCode', p).then(res => {
                ev.updatedBookingIds = res.data;
                ev.route = this.route;
                this.$emit('geocoded', ev);
            });
        },
        onStopGeoCoded(ev) {
            //Just pass
            this.$emit('geocoded',ev);
        },
        isolateAction(ev) {         
            this.$emit('isolateaction', { action: ev.action, stp: ev.stp, route: this.route });
        },
        isBookingMissingGeo(b) {
            return !(b.pickup.geo && b.delivery.geo);
        },
        autoGeoCodeRoute() {
            this.$emit('autogeocode', this.route);
        },
        onsetdrag(ev) {
            ev.routeId = this.route.id;
            this.$emit('setdrag', ev);
        },
        changeselected(ev, v) {
            console.log('selected in routedetails')
            this.$emit('setselect', v);
        },
        highlightOnMap(s) {
            if (s.place) {
                var p = s.place;
                var markers = [{ geoX: p.geo.geoX, geoY: p.geo.geoY, title: p.geo.text }];
                this.sendMapCommand('highlight', { markers: markers });
            }
        },
        highlightclear() {
            this.sendMapCommand('highlightclear')
        },
        sendMapCommand(cmd, data) {
            this.$emit('mapcommand', { cmd: cmd, data: data });
        },
        ondropToRoute() {
            var cntx = { type: 'route', route: this.route };
            this.$emit('drop', cntx);
        },
        dragStart_Stop(ev, s) {
            if (ev)
                ev.stopPropagation();

            var ctx = { type: 'stop', stop: s, routeId: this.route.id };
            this.$emit('setdrag', ctx)
        },
        ondropToStop(ev,s,i) {
            if (ev)
                ev.stopPropagation();

            var cntx = { type: 'stop', routeId: this.route.id, stop:s, idx:i };
            this.$emit('drop', cntx);
        },
        getRouteCommands() {
            if(this.cmds)
                return this.cmds;

            return [];
        },
        onroutecommand(ev,c) {
            if(ev)
                ev.stopPropagation();
            
            this.$emit('cmd',{cmd:c.cmd,route:this.route});
        },
        isStopSelected(s) {
            //TODO: determine this
            if(this.selectedStops)
                return this.selectedStops.findIndex(x => x.stop === s)>=0;

            return false;
        },
        setStopSelected(ev,s,v) {
            if(ev)
                ev.stopPropagation();
            //TODO: If we have a unique id on stop we dont need to send the route
            var ctx = {cmd:'stopselected',routeId:this.route.id,route:this.route, stop:s,value:v};
            this.$emit('cmd',ctx);
        },
        setAllStopSelected(ev,s,v) {
            if(ev)
                ev.stopPropagation();
            this.route.stops.filter(x => !x.locked).map(s => this.setStopSelected(ev,s,v));            
        },
        onStopWorkTimeChanged(ev,s) {
            var ctx = {cmd:'stopworktimechanged', stop:s, route: this.route, ...ev}
            this.$emit('cmd',ctx);
        },
        selectRoute() {
            var ctx = {cmd:'selectroute',routeId:this.route.id,route:this.route};
            this.$emit('cmd',ctx);
        }
    }
}


</script>
<style scoped>
.stoprow:hover {
    background-color: rgb(194, 120, 30);
}
.colorshow {
    border:1px;
    color:black;
    width:15px;
    height:40px;
    border-radius: 5px;
}
</style>